var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search-S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-S",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0958333,50.2041667 L79.1666667,73.275 L73.275,79.1666667 L50.2041667,56.0958333 C44.9458333,60.1125 38.375,62.5 31.25,62.5 C13.9916667,62.5 0,48.5083333 0,31.25 C0,13.9916667 13.9916667,0 31.25,0 C48.5083333,0 62.5,13.9916667 62.5,31.25 C62.5,38.3791667 60.1125,44.9458333 56.0958333,50.2041667 Z M31.25,8.33333333 C43.9041667,8.33333333 54.1666667,18.5916667 54.1666667,31.25 C54.1666667,43.9083333 43.9041667,54.1666667 31.25,54.1666667 C18.5916667,54.1666667 8.33333333,43.9083333 8.33333333,31.25 C8.33333333,18.5916667 18.5916667,8.33333333 31.25,8.33333333 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchS);
export default __webpack_public_path__ + "static/media/search-S.2d36ace177166cf476f1d4c7c8275971.svg";
export { ForwardRef as ReactComponent };